import * as api from '@/api/api';
import axios from 'axios';
let base = api.BaseApiUrl;

// export const httpUploadFile = (data) => {
//     return request({
//         url: '/api/blade-resource/oss/endpoint/put-file-attach',
//         method: 'post',
//         headers: {
//             "Content-Type": "multipart/form-data"
//         },
//         data
//     })
// }

const httpUploadFile = data => {
    return axios.post(`${base}/api/RecruitmentRegistration/FileSave`, data,
        {
            "Content-Type": "multipart/form-data"
        }
    );
};


export const uploadFile = (file, type = 5) => { //0 报名信息  1积分认定  2层次认定  3积分认定模板  4层次认定模板  5和10 后台文件  6 报名模板
    let formData = new FormData()
    formData.append('file', file)
    formData.append('name', file.name)
    formData.append('Type', type)
    formData.append('size', file.size)

    return new Promise(async (resolve, reject) => {
        let response = await httpUploadFile(formData)
        let status = response.status
        if (status == 200) {
            resolve(response.data)
        } else {
            reject(response.data)
        }
    })
}